/**
 * Normalizes `integrations_keys.tags` from DB (JSON string) or API (array of {key,value}).
 * Keep in sync with papaya/src/api/lib/integrationTags.ts.
 */
export function parseIntegrationTags(tags: unknown): Record<string, string> {
  const out: Record<string, string> = {}
  if (tags == null) return out
  let arr: any[] = []
  try {
    if (Array.isArray(tags)) arr = tags
    else if (typeof tags === 'string' && tags.trim()) arr = JSON.parse(tags)
  } catch {
    return out
  }
  arr.forEach((t) => {
    if (t && t.key != null) out[String(t.key)] = String(t.value ?? '')
  })
  return out
}

/** True when key_id is `{owner}--shippo` or `{owner}--shippo--...` (middle segment exactly `shippo`). */
export function isShippoIntegrationKeyId(keyId: string | undefined | null): boolean {
  if (keyId == null || keyId === '') return false
  return String(keyId).split('--')[1] === 'shippo'
}

/** Legacy single-connection key: exactly `{owner}--shippo` (disconnect with empty body). */
export function isShippoLegacyIntegrationKeyId(keyId: string | undefined | null): boolean {
  if (keyId == null || keyId === '') return false
  const parts = String(keyId).split('--')
  return parts.length === 2 && parts[1] === 'shippo'
}
